export default __webpack_public_path__ + "static/media/anatomy-of-a-seed.3556252a.png";